import React from 'react'
import { isLocal, isCms } from '../../../spa/utility'
import { getAbsolutePath } from '../../../global/environments/path.js'
import './index.css'
import DOMPurify from 'dompurify'

const bgImage = `${
  isLocal() || isCms() ? '/cti-site' : ''
}/webfiles/latest/assets/cti/images/brand-texture-light.jpg`

const bgStyles = {
  backgroundImage: `url(${bgImage})`,
}

function LoggedOutTray({ show }) {
  return (
    <div
      className={`${
        show ? 'consultant-container' : ''
      } consultant-contact-tray -logged-out u-sm-hidden`}
      style={bgStyles}
    >
      <div className="Grid u-flexJustifyEnd u-flexAlignItemsCenter u-sizeConstrained u-padding8gu">
        <div className="Grid-cell u-md-size5of12 u-lg-size4of12 u-textCenter">
          <div className="Card u-padding2gu u-marginBottom3gu u-flex">
            <div className="image-placeholder u-marginRight2gu u-textCenter u-textColorWhite">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="54px"
                viewBox="0 0 24 24"
                width="54px"
                fill="#ffffff"
              >
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>
            </div>
            <div className="u-flexGrow1 u-inlineBlock u-marginTop2gu">
              <div className="text-placeholder" />
              <div className="text-placeholder" />
              <div className="text-placeholder" />
            </div>
          </div>
          <p className="u-marginBottom3gu">
            We&apos;re here to help. Log in to connect with your sales
            consultant team.
          </p>
          <a
            href={DOMPurify.sanitize(`${getAbsolutePath(true)}/login`)}
            className="Button Button--primary u-text-uppercase u-block"
            data-analytics="sales-consultant-login-button"
          >
            Log in
          </a>
          <a
            href={DOMPurify.sanitize(`${getAbsolutePath(true)}/register`)}
            className="Button Button--tertiary u-text-uppercase u-block u-marginTop2gu"
            data-analytics="sales-consultant-create-account"
          >
            Create an account
          </a>
        </div>
      </div>
    </div>
  )
}

export default LoggedOutTray
